export function getApiBase() {
  const fallbackDev = "http://localhost:5000/api";
  const fallbackProd = "https://meetday.barbelltracker.com/api";
  const isDev = process.env.NODE_ENV === "development";

  return process.env.REACT_APP_API_BASE || (isDev ? fallbackDev : fallbackProd);
}
